@if (!!item) {
<svg height="100%" width="100%" viewBox="-24.7 8 249.4 304"
  xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient [attr.id]="'km-steel-' + item.id" x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stop-color="#b7bdc6"/>
      <stop offset="0.5" stop-color="#eef1f4"/>
      <stop offset="1" stop-color="#a7adb7"/>
    </linearGradient>
    <clipPath [attr.id]="'km-clip-' + item.id">
      <rect x="52" y="70" width="96" height="212" rx="8"/>
    </clipPath>
  </defs>

  <!-- Ball-lock posts on the lid -->
  <g fill="#c9ced6" stroke="#7f8790">
    <rect x="90.5" y="19" width="4" height="6" rx="1"/>
    <rect x="105.5" y="19" width="4" height="6" rx="1"/>
    <rect x="88" y="24" width="9" height="12" rx="2"/>
    <rect x="103" y="24" width="9" height="12" rx="2"/>
  </g>

  <!-- Tri-clamp lid: cap plate + clamp ring with wing bolts -->
  <rect x="84" y="36" width="32" height="7" rx="2" fill="#c9ced6" stroke="#7f8790"/>
  <rect x="79" y="42" width="42" height="9" rx="4" [attr.fill]="'url(#km-steel-' + item.id + ')'" stroke="#7f8790" stroke-width="1.5"/>
  <rect x="73" y="45" width="6" height="4" rx="1" fill="#9aa0a8" stroke="#6f767f"/>
  <rect x="121" y="45" width="6" height="4" rx="1" fill="#9aa0a8" stroke="#6f767f"/>

  <!-- Top dome under the chime -->
  <path d="M56 62 C64 48 136 48 144 62 Z" [attr.fill]="'url(#km-steel-' + item.id + ')'" stroke="#7f8790" stroke-width="1.5"/>

  <!-- Liquid fill (clipped to the keg interior) -->
  <rect [attr.clip-path]="'url(#km-clip-' + item.id + ')'" x="52" [attr.y]="y" [attr.height]="height" width="96" [attr.fill]="item.color || item.beverage?.color || '#d99a2b'"/>

  <!-- Keg body (translucent so the level reads) -->
  <rect x="48" y="64" width="104" height="222" rx="10" [attr.fill]="'url(#km-steel-' + item.id + ')'" fill-opacity="0.42" stroke="#0f0f0f" stroke-width="1.5"/>

  <!-- Rolled ribs -->
  <g [attr.fill]="'url(#km-steel-' + item.id + ')'" fill-opacity="0.75" stroke="#7f8790" stroke-width="1">
    <rect x="48" y="112" width="104" height="9" rx="4.5"/>
    <rect x="48" y="196" width="104" height="9" rx="4.5"/>
  </g>

  <!-- Top chime with handle cutouts -->
  <rect x="50" y="56" width="100" height="14" rx="6" [attr.fill]="'url(#km-steel-' + item.id + ')'" stroke="#7f8790" stroke-width="1.5"/>
  <rect x="62" y="60" width="24" height="5" rx="2.5" fill="#7f8790" opacity="0.55"/>
  <rect x="114" y="60" width="24" height="5" rx="2.5" fill="#7f8790" opacity="0.55"/>

  <!-- Bottom chime -->
  <rect x="50" y="280" width="100" height="14" rx="6" [attr.fill]="'url(#km-steel-' + item.id + ')'" stroke="#7f8790" stroke-width="1.5"/>

  <!-- Silhouette -->
  <path d="M48 72 L48 284 M152 72 L152 284" fill="none" stroke="#7f8790" stroke-width="1.2" opacity="0.7"/>
</svg>
}
